module.exports = __webpack_public_path__ + "img/white.22ebb3d0.png";